var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('BaseButton',{attrs:{"primary":""},on:{"click":_vm.createContact}},[_vm._v(" "+_vm._s(_vm.$t('accountContacts.newContact'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }